export default "__VITE_ASSET__Blm2vhMx__"